import { useContext } from 'react';
import { CookieConsentContext } from '../contexts/CookieConsentContext';
import type { CookieConsentContextType } from '../types/cookieConsent';

export function useCookieConsent(): CookieConsentContextType {
  const context = useContext(CookieConsentContext);
  if (!context) {
    throw new Error('useCookieConsent must be used within a CookieConsentProvider');
  }
  return context;
}
